import { Modal } from "antd";
import { uniqBy } from "lodash";
import { useEffect, useState } from "react";
import { Directory } from "../select/directory/Directory";
import { DirectoryProvider } from "../select/directory/DirectoryContext";

const ModalAddMember = ({
  isModalOpen,
  setIsModalOpen,
  count,
  setCount,
  participants,
  setParticipants,
  projectManager,
  conversationId,
}) => {
  const [orgList, setOrgList] = useState([]);
  const [existedMemberIds, setExistedMemberIds] = useState([]);
  const [isReady, setIsReady] = useState(false);

  const handleOk = () => {
    let members = uniqBy(
      orgList?.filter((org) => org?.type === "PERSON" && org?.checked),
      "objectId",
    );
    let key = count;
    const memberList = [];

    members.forEach((member) => {
      const dataMember = {
        key: key,
        objectId: member.objectId,
        code: member.objectId,
        name: member.name,
        role: null,
        authority: null,
      };

      memberList.push(dataMember);
      key++;
    });
    setParticipants([...participants, ...memberList]);
    setCount(key);
    setIsModalOpen(false);
  };

  const cancelModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (participants.length > 0) {
      const memberIds = participants.map(
        (participant) => participant?.objectId || participant?.userId,
      );
      setExistedMemberIds([...memberIds, projectManager?.objectId]);
    } else {
      setExistedMemberIds([projectManager?.objectId]);
    }

    setIsReady(true);
  }, [participants]);

  return (
    <Modal
      title="Modal add members"
      open={isModalOpen}
      closeIcon={false}
      onOk={handleOk}
      onCancel={cancelModal}
      closable
      width={1200}
    >
      {isReady && (
        <DirectoryProvider
          orgList={orgList}
          setOrgList={setOrgList}
          isOpen={isModalOpen}
          conversationId={conversationId}
          existedMemberIds={existedMemberIds}
        >
          <Directory />
        </DirectoryProvider>
      )}
    </Modal>
  );
};

export default ModalAddMember;
